import { ProgressWrenchIcon } from './ProgressWrenchIcon';

/**
 * author: Michael Irigoyen
 * id D0721C85-4507-43CE-8E0B-21522D641993
 * name progress-wrench
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/progress-wrench.svg
 * tags
 * - Hardware / Tools 
 */
export const ProgressSpannerIcon = ProgressWrenchIcon;
export default ProgressSpannerIcon